import { Menu, MenuItem, Select } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { SALES_AUDIT_OPTIONS_MAP } from "../../../data/constants";
import { useDispatch } from "react-redux";
import { getAuditLogDetails, getSubFilterDetails } from "../../../redux/slices";
import AuditSubFilterDropdown from "./audit-sub-filter-dropdown";

interface Props {
  getPayload: any;
  auditFilterDetails: any;
  onSelectedIdChange: any;
  handleonSelectedItemChange: any;
  defaultSelectedId: string;
  defaultSelectedSubType: string;
}

function TypeSelectDropdown(props: Props) {
  const {
    getPayload,
    auditFilterDetails,
    onSelectedIdChange,
    handleonSelectedItemChange,
    defaultSelectedId,
    defaultSelectedSubType,
  } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedItemId, setSelectedItemId] =
    useState<string>(defaultSelectedId);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (itemId: string) => {
    let dataToPost = getPayload();
    setSelectedItemId(itemId);
    if (itemId !== SALES_AUDIT_OPTIONS_MAP.allorders.id) {
      dataToPost["auditType"] =
        SALES_AUDIT_OPTIONS_MAP[itemId].label ||
        SALES_AUDIT_OPTIONS_MAP[defaultSelectedId].label;
    }

    if (itemId === SALES_AUDIT_OPTIONS_MAP.allorders.id) {
      delete dataToPost?.auditType;
      delete dataToPost?.auditSubType;
    }
    dispatch(getAuditLogDetails({ dataToPost }));
    dispatch(getSubFilterDetails({ dataToPost }));
    handleClose();
    onSelectedIdChange(SALES_AUDIT_OPTIONS_MAP[itemId].id);
  };

  return (
    <>
      <div className="flex justify-between type-select-dropdown-container border-b-[1px] px-16 py-12">
        <div
          className="flex w-fit justify-center items-center cursor-pointer rounded-dropdown-btn !rounded-[8px] overflow-hidden h-[41px] bg-[#0000000D] p-12 hover:border-[1px] hover:border-black hover:transition-transform hover:transform hover:scale-100 "
          onClick={handleClick}
        >
          <div className="rista-sprite ic-sort-dropdown "></div>

          <div className="ml-[8px] text-[14px] font-normal">
            {SALES_AUDIT_OPTIONS_MAP[selectedItemId]?.type}
          </div>
        </div>
        {auditFilterDetails?.auditSubTypes?.length > 0 && (
          <AuditSubFilterDropdown
            auditFilterDetails={auditFilterDetails}
            getPayload={getPayload}
            selectedItemId={selectedItemId}
            onSelectedItemChange={handleonSelectedItemChange}
            defaultSelectedSubType={defaultSelectedSubType}
          />
        )}
      </div>
      <Menu id="basic" anchorEl={anchorEl} open={open} onClose={handleClose}>
        {Object.values(SALES_AUDIT_OPTIONS_MAP).map((item) => (
          <MenuItem
            key={item.id}
            onClick={() => {
              setSelectedItemId(item.id);
              handleMenuItemClick(item.id);
              handleClose();
            }}
            className="hover:font-semibold overflow-auto"
          >
            {item.type}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
export default TypeSelectDropdown;
